import { defineComponent as _defineComponent } from 'vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { isCardSectionActive } from '@/utils/format-edit/cardSections'
import favoritesConfig from '@/utils/format-edit/myprofileFavoritesConfig.json'
import {
  setStringListItem,
  stringListItem
} from '@/utils/format-edit/myprofileFields'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyprofileFavoritesCard',
  props: {
    currentCardId: null,
    formatId: null
  },
  setup(__props: any) {

const props = __props as {
  currentCardId?: string
  formatId?: string
};



const formatData = useRirekishoFormatData()

const isSection = (section: string) =>
  isCardSectionActive(props.formatId, props.currentCardId, section)

function favoriteItem(idx: number) {
  return stringListItem(formatData.favorites, idx)
}

function setFavorite(idx: number, val: string) {
  setStringListItem(formatData, 'favorites', idx, val, 6)
}

return { __sfc: true,props, formatData, isSection, favoriteItem, setFavorite, favoritesConfig }
}

})